/*
 * @Descripttion: 
 * @version: 
 * @Author: renqiang_hu
 * @Date: 2023-02-23 16:49:25
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2023-02-24 11:31:30
 * @FilePath: \common_web\src\api\search.js
 */
import request from '@/router/axios'

export const searchurl = {
      //故障类型
      listAlarmType(data){
        return request({
            url: '/api/alarmCommonExplain/listAlarmType',
            method: 'get',
            params: data
          })
      },
      genArchivelist(data){
        return request({
            url: '/api/generalArchive/list',
            method: 'get',
            params: data
          })
      },
      shopArchivelist(data){
        return request({
          url: '/api/shopArchive/list',
          method: 'get',
          params: data
        })
      },
      areaArchivelist(data){
        return request({
          url: '/api/areaArchive/list',
          method: 'get',
          params: data
        })
      },
      // 装机订单 单号
      shopcodeList (data){
        return request({
          url: '/api/shopApplyDevice/code/list',
          method: 'get',
          params: data
        })
      },
      // 收款机时 单号
      shopBuyMachinehourlist (data){
        return request({
          url: '/api/shopBuyMachinehour/list/orderCode',
          method: 'get',
          params: data
        })
      },
      
      // 总代订单 单号
      gencodeList (data){
        return request({
          url: '/api/generalItemOrder/code/list',
          method: 'get',
          params: data
        })
      },
        // 店铺订单 单号
      shopItemOrderlist (data){
        return request({
          url: '/api/shopItemOrder/code/list',
          method: 'get',
          params: data
        })
      },
      // 总代仓库订单号
      genwarehouselist (data){
        return request({
          url: '/api/general/warehouse/order/code/list',
          method: 'get',
          params: data
        })
      },
      
      
      shopArchiveBanklist(data) {
        return request({
          url: '/api/shopArchiveBank/list',
          method: 'get',
          params: data
        })
      },
      genArchiveBanklist(data) {
        return request({
          url: '/api/generalArchiveBank/list',
          method: 'get',
          params: data
        })
      },
       // 投诉单号查询
       generalComplaintCodeList (data){
        return request({
          url: '/api/generalComplaint/code/list',
          method: 'get',
          params: data
        })
      },

        // 维修单号查询
        shopAlarmCodeList (data){
          return request({
            url: '/api/shopAlarm/code/list',
            method: 'get',
            params: data
          })
        },
      // 投诉对象
      generalComplaintListComplaintObject (data){
        return request({
          url: '/api/generalComplaint/listComplaintObject',
          method: 'get',
          params: data
        })
      },
    // genArchivelist(data) => {
    //     return request({
    //       url: '/api/generalArchive/list',
    //       method: 'get',
    //       params: data
    //     })
    //   }
}
// //店铺名称 编码列表
// export const shopArchivelist = (data) => {
//     return request({
//       url: '/api/shopArchive/list',
//       method: 'get',
//       params: data
//     })
//   }
//   export const areaArchivelist = (data) => {
//     return request({
//       url: '/api/areaArchive/list',
//       method: 'get',
//       params: data
//     })
//   }
//   export const genArchivelist = (data) => {
//     return request({
//       url: '/api/generalArchive/list',
//       method: 'get',
//       params: data
//     })
//   }

//   // 店铺单号
//   export const shopcodeList = (data) => {
//     return request({
//       url: '/api/shopApplyDevice/code/list',
//       method: 'get',
//       params: data
//     })
//   }

//   // 银行卡号
//   export const shopArchiveBanklist = (data) => {
//     return request({
//       url: '/api/shopArchiveBank/list`',
//       method: 'get',
//       params: data
//     })
//   }


